import { jsx as t, jsxs as s } from "react/jsx-runtime";
import * as l from "react";
import * as e from "@radix-ui/react-dialog";
import { X as d } from "lucide-react";
import { cn as i } from "../../../lib/utils.js";
import { motion as c } from "framer-motion";
const u = e.Root, w = e.Trigger, C = e.Close, p = e.Portal, m = l.forwardRef(({ className: a, ...o }, r) => t(e.Overlay, { ref: r, asChild: !0, ...o, children: t(c.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, className: i("fixed inset-0 z-40 bg-lpr-teal/10 dark:bg-lpr-charcoal/60 backdrop-blur-xl", a) }) }));
m.displayName = e.Overlay.displayName;
const f = l.forwardRef(({ className: a, children: o, ...r }, n) => s(p, { children: [t(m, {}), t(e.Content, { ref: n, asChild: !0, ...r, children: s(c.div, { initial: { opacity: 0, scale: 0.95, y: "-45%", x: "-50%" }, animate: { opacity: 1, scale: 1, y: "-50%", x: "-50%" }, exit: { opacity: 0, scale: 0.95, y: "-45%", x: "-50%" }, transition: { type: "spring", stiffness: 400, damping: 30 }, className: i("fixed left-[50%] top-[50%] z-50 w-[calc(100vw-2rem)] max-w-lg rounded-2xl bg-[var(--bg-surface)] border-2 border-[var(--border-color)] p-8 shadow-luxury focus:outline-none", a), children: [o, t(e.Close, { className: "absolute right-6 top-6 rounded-full p-1 opacity-20 transition-all hover:opacity-100 hover:bg-border-color active:scale-90", children: t(d, { className: "h-5 w-5 text-[var(--text-primary)]" }) })] }) })] }));
f.displayName = e.Content.displayName;
const y = ({ className: a, ...o }) => t("div", { className: i("flex flex-col space-y-1.5 text-center sm:text-left mb-3", a), ...o });
y.displayName = "DialogHeader";
const x = l.forwardRef(({ className: a, ...o }, r) => t(e.Title, { ref: r, className: i("text-lg font-bold text-[var(--text-primary)]", a), ...o }));
x.displayName = e.Title.displayName;
const g = l.forwardRef(({ className: a, ...o }, r) => t(e.Description, { ref: r, className: i("text-sm text-[var(--text-secondary)]", a), ...o }));
g.displayName = e.Description.displayName;
const v = ({ className: a, ...o }) => t("div", { className: i("mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-0 sm:space-x-2", a), ...o });
v.displayName = "DialogFooter";
export {
  u as Dialog,
  C as DialogClose,
  f as DialogContent,
  g as DialogDescription,
  v as DialogFooter,
  y as DialogHeader,
  m as DialogOverlay,
  p as DialogPortal,
  x as DialogTitle,
  w as DialogTrigger
};
//# sourceMappingURL=Dialog.js.map
